/**
 * My Goals State Types
 *
 * Type definitions for the MyGoals state slice.
 * Database-backed state with real-time Firestore sync filtered by user's caseload.
 */

import { AugmentedGoal } from 'src/app/domain/goals/types/Goal.model';

/** Signal state model for the MyGoalsState slice. */
export interface MyGoalsStateModel {
  // === Data ===
  data: AugmentedGoal[];

  // === Status Flags ===
  initialized: boolean;
  loading: boolean;
  error: string | null;

  // === Metadata ===
  lastUpdated: number | null;
  lastSync: number | null;

  // === Context ===
  activeTeamId: string | null;
  caseload: string[];
}

/** Configuration required to initialize MyGoalsState for a practitioner's caseload. */
export interface MyGoalsInitConfig {
  activeTeamId: string;
  caseload: string[];
  enableRealtimeUpdates?: boolean;
  /** Additional teams to load goals from and merge into this state (no realtime listener). */
  additionalTeamContexts?: Array<{ teamId: string; caseload: string[] }>;
}

export const MY_GOALS_DEFAULTS: MyGoalsStateModel = {
  data: [],
  initialized: false,
  loading: false,
  error: null,
  lastUpdated: null,
  lastSync: null,
  activeTeamId: null,
  caseload: [],
};
